import axios from 'axios';
import { subscriptionListAction } from './SubscriptionsListSlice';

const getSubscriptionListData = () => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/subscription/plans`;
      const response = await axios.get(url, {});
      return response;
    };
    try {
      const result = await fetchData();
      const subscriptionListData = result.data;
      dispatch(subscriptionListAction.subscriptionListHandler({ subscriptionListData }));
    } catch (e) {}
  };
};

export default getSubscriptionListData;